export default [
  {
    path: 'M38.68444445 694.04444445v-388.36148111h97.09036998l145.63555556 145.63555556 145.63555556-145.63555556h97.09037112v388.36148111h-97.09037112v-250.97860779l-145.63555556 145.63555555-145.63555556-145.63555555v250.97860779h-97.09036998m679.63259221-388.36148111h145.63555555v194.18073999h121.36296334l-194.18074112 218.45333333-194.18073998-218.45333333h121.36296221z',
    fill: '#42A5F5',
  },
]
